export enum ksaQuestionOperations {
  setPageBreak = 1,
  setDescriptionText = 2,
  setMatrixAnswerLabel = 3,
  setRoleProfileItems = 4
}
